import { render, staticRenderFns } from "./questionnaireCard.vue?vue&type=template&id=5340172c&scoped=true"
import script from "./questionnaireCard.vue?vue&type=script&lang=js"
export * from "./questionnaireCard.vue?vue&type=script&lang=js"
import style0 from "./questionnaireCard.vue?vue&type=style&index=0&id=5340172c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5340172c",
  null
  
)

export default component.exports